import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MasterDataService} from '../master-data/master-data-service';
import {Attribute} from '../master-data/master-data.model';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserAttributesResolver{
  private masterDataService = inject(MasterDataService);


  getUserAttributes(): Observable<Attribute[]> {
    return this.masterDataService.getUserAttributes();
  }
}

export const userAttributesResolver: ResolveFn<Attribute[]> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(UserAttributesResolver).getUserAttributes();
  };
